"use strict";
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadImageFromUrl = void 0;
var dom = __importStar(require("./domElements.ts"));
var config = __importStar(require("./config.ts"));
var state = __importStar(require("./state.ts"));
var canvasManager_ts_1 = require("./canvasManager.ts");
var animationManager_ts_1 = require("./animationManager.ts");
// The handleImageUpload function has been removed as file uploads are no longer supported.
function loadImageFromUrl(imageUrl) {
    state.setLoadedImage(null);
    state.setImageLayoutMode(null);
    state.setPermanentFlowers([]);
    state.setActiveEffects([]);
    state.setCurrentColorPalette(__spreadArray([], config.DEFAULT_PALETTE, true)); // Use fixed default palette
    if (state.baseLayerCtx && state.baseLayerCanvas) {
        state.baseLayerCtx.clearRect(0, 0, state.baseLayerCanvas.width, state.baseLayerCanvas.height);
    }
    if (state.animationFrameId) {
        cancelAnimationFrame(state.animationFrameId);
        state.setAnimationFrameId(null);
    }
    (0, canvasManager_ts_1.renderCanvas)();
    var img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = function () {
        state.setLoadedImage(img);
        // Set the layout mode based on the URL loaded
        if (imageUrl === config.MOBILE_IMAGE_URL) {
            state.setImageLayoutMode("mobile");
        }
        else {
            state.setImageLayoutMode("desktop");
        }
        if (state.baseLayerCanvas && state.baseLayerCtx) {
            state.baseLayerCanvas.width = dom.canvas.width; // Ensure dimensions match
            state.baseLayerCanvas.height = dom.canvas.height;
            (0, canvasManager_ts_1.drawImageToBaseLayer)(img);
        }
        // Palette is already set to the fixed default, no generation needed.
        state.setCurrentColorPalette(__spreadArray([], config.DEFAULT_PALETTE, true)); // Ensure fixed palette
        state.setPermanentFlowers([]);
        state.setActiveEffects([]);
        state.setSweepPauseEndTime(performance.now() + config.SWEEP_PAUSE_DURATION_MS);
        state.setIsSweeping(false);
        state.setSweepLineY(-1);
        (0, animationManager_ts_1.startAnimation)();
    };
    img.onerror = function () {
        state.setLoadedImage(null);
        state.setImageLayoutMode(null);
        state.setCurrentColorPalette(__spreadArray([], config.DEFAULT_PALETTE, true));
        if (state.baseLayerCtx && state.baseLayerCanvas) {
            state.baseLayerCtx.clearRect(0, 0, state.baseLayerCanvas.width, state.baseLayerCanvas.height);
        }
        (0, canvasManager_ts_1.renderCanvas)();
        (0, animationManager_ts_1.startAnimation)();
    };
    img.src = imageUrl;
}
exports.loadImageFromUrl = loadImageFromUrl;
